// extracted by mini-css-extract-plugin
export default {"overlay":"custom-popup_overlay__4gCl-","popup":"custom-popup_popup__dQIhK","close":"custom-popup_close__vNGsl","content":"custom-popup_content__UliLJ"};